import { clearInputField, getQueryStringParameter } from '../../../helpers.js'

$(document).ready(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'us_person') {
    return;
  }

  const $americanLawEntity = $('#americanLawEntity input[type=radio]', $form);

  $americanLawEntity.on('click', (inputElement) => {
    $form.submit();
  });
})
